import React from 'react'; 
import { services } from "../data/services";

export const CprFirstAidService = () => {
	const source = require("../data/cpr.json");
	const data = source["cprService"];

	return (
		<>
			<div className="home-consulting big-section cover-background"
				style={{
					backgroundColor: '#faf6f3',
					marginBottom: '20px'
				}}>
				<h2 className="text-center py-4" style={{ color: "#1B3A4B" }}>
					CPR & First Aid Training
				</h2>
				<div className="d-flex justify-content-around" style={{ marginBottom: '20px' }}>
					{Object.entries(data).map(([label, image]) => (
						<div key={label} className="text-center" style={{ width: "15%" }}>
							<img
								src={require(`../gallery/cpr/${image}`).default}
								alt={label}
							/>
							<div style={{
								color: "#000",
								fontSize: "15px",
								marginTop: "5px"
							}}>
								{label}
							</div>
						</div>
					))}
				</div>
			</div>
		</>
	)
}
